import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { KioskButton } from '../components/KioskButton';
import { KioskFrame } from '../components/KioskFrame';
import { SupervisorPinModal } from '../components/SupervisorPinModal';
import { useKiosk } from '../lib/session';

/**
 * 報到查詢與引導 — Flow 3.13。
 *
 * KIOSK 不直接報到（status→used 由現場票務人員之 PWA 完成）；本頁僅做：
 *   - 引導顧客至登船口由人員掃碼
 *   - 常見問題提示（找不到票 / 掃不到 / 沒收到）
 *   - 督導例外通道（PIN modal）— UI scaffold，後端 D-2 manual_override 待接
 *
 * 對應 docs/PRD §D-1（buyer 自助）+ Flow 3.13 註。
 */
export function CheckInScreen(): JSX.Element {
  const navigate = useNavigate();
  const { t } = useKiosk();
  const [supervisorOpen, setSupervisorOpen] = useState(false);

  return (
    <KioskFrame>
      <h1 className="k-h1">{t('checkin.title')}</h1>

      <div className="k-card" style={{ textAlign: 'center' }}>
        <div
          style={{
            border: '3px dashed var(--c-primary)',
            borderRadius: 18,
            padding: '64px 24px',
            color: 'var(--c-primary)',
            fontSize: 'var(--fs-h2)',
            fontWeight: 700,
          }}
        >
          📷
          <div style={{ marginTop: 12 }}>{t('checkin.scanArea')}</div>
        </div>
      </div>

      <p className="k-text" style={{ fontWeight: 600, marginBottom: 6 }}>
        {t('checkin.guideLine1')}
      </p>
      <p className="k-text k-text--dim">{t('checkin.guideLine2')}</p>

      <div className="k-card" style={{ marginTop: 28 }}>
        <h2 className="k-h2">{t('checkin.helpTitle')}</h2>
        <ul
          style={{
            listStyle: 'disc',
            paddingLeft: 28,
            fontSize: 'var(--fs-body)',
            lineHeight: 1.6,
          }}
        >
          <li>{t('checkin.help1')}</li>
          <li>{t('checkin.help2')}</li>
          <li>{t('checkin.help3')}</li>
        </ul>
        <p className="k-text k-text--dim" style={{ marginTop: 12 }}>
          ⓘ {t('checkin.staffPrompt')}
        </p>
      </div>

      <div className="k-footbar">
        <KioskButton variant="secondary" onClick={() => navigate('/home')}>
          ← {t('common.home')}
        </KioskButton>
        <KioskButton
          variant="warning"
          block
          onClick={() => setSupervisorOpen(true)}
          data-testid="kiosk-supervisor-open"
        >
          🔒 {t('checkin.supervisor')}
        </KioskButton>
      </div>

      <SupervisorPinModal open={supervisorOpen} onClose={() => setSupervisorOpen(false)} />
    </KioskFrame>
  );
}
